import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Utils } from '../../../utils/utils';
import {AlertifyService, ConfirmModalComponent, PrefixService, UserStore, UtilsGlobals} from 'ccc-commons/core';
import { AccountLicenses, AccountProduct } from '../../../../core/models/accountLicenses';
import { AccountsService } from '../../../../core/services/accounts.service';

@Component({
  selector: 'ccc-cca-user-license-modal',
  templateUrl: './license-modal.component.html',
  styleUrls: ['./license-modal.component.scss']
})
export class UserLicenseModalComponent implements OnInit {

  @ViewChild('content')
  content: NgbModal;

  @ViewChild('confirmModal')
  confirmModal: ConfirmModalComponent;

  @ViewChild('modalCancel')
  modalCancel: ConfirmModalComponent;

  @ViewChildren('productCheckbox')
  productCheckboxes: QueryList<ElementRef<HTMLInputElement>>;

  isLoading = false;

  modal: any;
  accountName;
  accountId;
  organizationName;
  organizationId;

  accountPrograms: AccountLicenses[];
  accountProgramInitState: any;

  isEditing = false;
  allSelected = false;
  hasPermissionToEdit = false;

  constructor(private modalService: NgbModal,
              private accountsService: AccountsService,
              private utils: Utils,
              private commonsUtils: UtilsGlobals,
              private alertify: AlertifyService,
              private userStore: UserStore,
              private prefix: PrefixService) { }

  ngOnInit() {
    this.hasPermissionToEdit = true;
  }

  open(accountId, accountName, orgId, orgName) {

    this.accountId = accountId;
    this.accountName = accountName;
    this.organizationId = orgId;
    this.organizationName = orgName;

    this.setDefaultvalues();
    this.getAccountLicenses();
    this.isLoading = true;

    this.modal = this.modalService.open(this.content, {
      centered: true,
      windowClass: 'animated faster zoomIn modal-custom ccc-new-modal',
      size: 'lg',
      backdrop: 'static',
      beforeDismiss: () => {
        if (this.isEditing) {
          this.modalCancel.onOpen();
          return false;
        }
        return true;
      }
    });

    this.modal.result.then(
      () => {
        this.setDefaultvalues();
      },
      () => {
        if (this.isEditing) {
          this.confirmModal.onOpen();
        }
      }
    );
  }

  onDismiss() {
    this.modal.dismiss();
  }

  setDefaultvalues() {
    this.accountPrograms = [];
    this.accountProgramInitState = [];
    this.isEditing = false;
  }

  /**
   * getAccountLicenses
   * get all the programs and products of the account
   * sort them by sequence, and set the initial state
   * if there is an error, show an alert
   */
  private getAccountLicenses(): void {

    const params = {
      organizationId: this.organizationId
    };

    this.accountsService.getAccountLicenses(this.accountId, params).subscribe((resp) => {
      this.accountPrograms = resp.body;
      this.sortGradesBySequence();
      this.accountProgramInitState = this.utils.deepCopy(this.accountPrograms);
      this.switchSelectUnselectAll();
      this.isLoading = false;
      setTimeout(() => {
        this.productCheckboxes.first.nativeElement.focus();
      });
    }, error => {
      this.isLoading = false;
      let message = '';
      const errors = error.error;
      if (Array.isArray(errors.message)) {
        for (const msg of errors.message) {
          for (const err of msg.errors) {
            message += err.charAt(0).toUpperCase() + err.slice(1) + '\n';
          }
        }
      } else {
        message += errors;
      }
      this.alertify.error(message);
    });
  }

  /**
   * sortGradesBySequence
   * for each program in the account, it sorts the products by sequence number
   */
  private sortGradesBySequence(): void {
    this.accountPrograms.forEach(program => {
      program.products = this.commonsUtils.sortBy(program.products, 'sequence', '-');
    });
  }

  switchSelectUnselectAll() {
    let programsAssigned = 0;
    let programsCount = 0;

    for (const program of this.accountPrograms) {
      for (const product of program.products) {
        if (product.assigned) {
          programsAssigned++;
        }
        programsCount++;
      }
    }

    if (programsAssigned === programsCount) {
      this.allSelected = true;
    } else {
      this.allSelected = false;
    }
  }

  isProgramProductSelected(programProducts: AccountProduct[]) {
    for (const program of programProducts) {
      if (program.assigned) {
        return true;
      }
    }
    return false;
  }

  sortProducts(products: AccountProduct[]) {
    return products.sort((a: AccountProduct, b: AccountProduct) => {
      return (a.sequence >= b.sequence) ? 0 : -1;
    });
  }

  selectAll() {
    this.allSelected = true;
    this.isEditing = true;
    this.setProgramAssigned(true);
  }

  unSelectAll() {
    this.allSelected = false;
    this.isEditing = true;
    this.setProgramAssigned(false);
  }

  setProgramAssigned(isAssigned) {
    for (const program of this.accountPrograms) {
      for (const product of program.products) {
        product.assigned = isAssigned;
      }
    }
  }


  selectLicense(event, product: AccountProduct) {
    this.isEditing = true;
    product.assigned = event.currentTarget.checked;
    this.switchSelectUnselectAll();
  }


  onSubmit() {

    const params = {
      organizationId: this.organizationId
    };

    this.accountsService.updateAccountLicenses(this.accountId, this.accountPrograms, params).subscribe((resp) => {
      this.isEditing = false;
      this.alertify.success('License Account updated successfully');

      this.setDefaultvalues();
      this.modal.close();

    }, error => {
      let message = '';
      const errors = error.error;
      if (Array.isArray(errors.message)) {
        for (const msg of errors.message) {
          for (const err of msg.errors) {
            message += err.charAt(0).toUpperCase() + err.slice(1) + '\n';
          }
        }
      } else {
        message += errors;
      }

      this.alertify.error(message);
    });
  }

  onCloseConfirmModal(close) {
    if (this.isEditing && close) {
      this.cancelEditingLicenses();
    }
    if (close) {
      this.modal.close();
    }
  }

  cancelEditingLicenses() {
    this.accountPrograms = this.utils.deepCopy(this.accountProgramInitState);
    this.isEditing = false;
  }

}
